import { useTranslation } from 'react-i18next';
import { getFeatureCode, getVariableSalesText, isSubmodelCountVariable } from '../services';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import type { ISalesTextProps } from '../../types';
import { AppStore } from '../store';

/**
 * Renders the short sales text popup.
 * @param {ISalesTextProps} props the properties for the short sales text component
 * @returns {JSX.Element} the short sales text popup component
 */
export const SalesText = ({ variable }: ISalesTextProps) => {
  const { t } = useTranslation();

  if (!variable) {
    return null;
  }
  const configuration = AppStore.getState().configuration;
  const id = isSubmodelCountVariable(variable)
    ? getFeatureCode(variable.id, variable.variableType)
    : (variable.id ?? variable.value);
  const salesText = getVariableSalesText(configuration.longSalesText, id ?? '');
  let longSaleText = null;
  try {
    longSaleText = salesText ? JSON.parse(salesText) : salesText;
  } catch {
    longSaleText = salesText;
  }
  return longSaleText ? (
    <div className="salesText"> {parse(DOMPurify.sanitize(longSaleText))} </div>
  ) : (
    <p className="noTextMessage">{t('salesText.noSalesText')}</p>
  );
};
